import { render, staticRenderFns } from "./AlarmList.vue?vue&type=template&id=820ed4be&scoped=true"
import script from "./AlarmList.vue?vue&type=script&lang=ts"
export * from "./AlarmList.vue?vue&type=script&lang=ts"
import style0 from "./AlarmList.vue?vue&type=style&index=0&id=820ed4be&prod&lang=css"
import style1 from "./AlarmList.vue?vue&type=style&index=1&id=820ed4be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "820ed4be",
  null
  
)

export default component.exports